
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import AddressView from "./components/address/AddressView";
import AdsDashboard from './components/admin/AdsDashboard';
import ChatApp from './components/admin/ChatApp';
import ECommerce1 from './components/admin/ECommerce1';
import ECommerce2 from './components/admin/ECommerce2';
import InvoicePage from './components/admin/InvoicePage';
import MailboxApp from './components/admin/MailboxApp';
import OrderDashboard from './components/admin/OrderDashboard';
import Org from './components/admin/Org';
import PayStub from './components/admin/PayStub';
import SEODashboard from './components/admin/SEODashboard';
import TrafficDashboard from './components/admin/TrafficDashboard';
import Cart from './components/cart/Cart';
import EmptyCart from './components/cart/EmptyCart';
import CategoryView from './components/category/CategoryView';
import Checkout from './components/checkout/Checkout';
import ClassroomSetup from './components/classroom/ClassroomSetup';
import Contact from './components/contacts/Contact';
import ContactsView from './components/contacts/ContactView';
import { CartProvider } from './components/context/CartProvider';
import { CategoryProvider } from './components/context/CategoryContext';
import { DomainProvider } from './components/context/DomainProvider';
import { GeographyProvider } from './components/context/GeographyProvider';
import { MiscProvider } from './components/context/MiscProvider';
import { NavProvider } from './components/context/NavProvider';
import { UserProfileProvider } from './components/context/UserProfileProvider';
import Builder from './components/demo/Bulder';
import RocketDemoBuilderForm from './components/demo/RocketDemoBuilderForm';
import Domain from './components/domain/Domain';
import UploadEntities from './components/entity/UploadEntites';
import FooterDynamic from './components/FooterDynamic';
import Home from './components/Home';
import View from './components/image/View';
import InventoryView from './components/inventory/Inventory';
import NoInventory from "./components/inventory/NoInventory";
import Products from './components/inventory/Products';
import Shop from './components/inventory/Shop';
import Invoice from './components/invoice/Invoice';
import ExpensesLanding from './components/landing/ExpensesLanding';
import Location from './components/location/Location';
import GroupUserManager from './components/login/profile/RoleGroupManager';
import User from './components/login/profile/User';
import UserProfile from "./components/login/profile/UserProfile";
import UsersView from './components/login/profile/UsersView';
import CreateThumbnail from './components/marketing/thumbnails/CreateThumbNail';
import Navbar from './components/Navbar';
import NoOrders from './components/orders/NoOrders';
import Orders from './components/orders/Orders';
import CreateYourCompany from './components/presentation/CreateYourCompany';
import IdCards from './components/presentation/IdCards';
import Pricing from './components/pricing/Pricing';
import PrivacyPolicy from './components/privacy/PrivacyPolicy';
import MultiView from './components/products/MutiView';
import Processed from './components/products/Processed';
import UnProcessed from './components/products/UnProcessed';
import QRCodes from './components/QR/QRCodes';
import NoReceipts from './components/receipts/NoReceipts';
import Receipt from './components/receipts/Receipt';
import NoRequests from './components/requests/NoRequests';
import Requests from './components/requests/Requests';
import Sidenav from "./components/SideNav";
import Dashboard from './components/statistics/Dashboard';
import Report from './components/statistics/Report';
import Statistics from "./components/statistics/Statistics";
import UnderConstruction from './components/UnderConstruction';
import JavenHome from './JavenHome';
import JDesk from './JDesk';



function ProtectedRoute({ element: Component, routeType, ...rest }) {


  // if (!tokenLoaded) {
  //   const FallbackComponent = componentMapping[routeType?.name] || Products; // Default to Home if routeType.name does not exist
  //   if (routeType && routeType.name === 'Shop') {
  //     return <FallbackComponent categoryId={categoryId} />;
  //   }
  //   return <FallbackComponent />;
  // }

  return <Component {...rest} />;
}

ProtectedRoute.propTypes = {
  element: PropTypes.elementType.isRequired,
  routeType: PropTypes.func,
};


export const MessageContext = React.createContext();

const  App = ()=> {
  console.log('App rendered');
 
 
  const [showNavCentred, setShowNavCentred] = useState(false);
  const toggle3barIcon = () => setShowNavCentred(!showNavCentred);
  

 



  // ensure this is correct
 // const cleanedInventoryUrl = inventoryUrl.replace('https://', '');
  //const hostname = process.env.REACT_APP_MY_HOSTNAME;

// State hook to control the visibility of the modal

 /* global FB */



  const containerRef = useRef(null); 
 





  // if (checkingToken || !isIPLocationReady) {
  //   return <div className='d-flex justify-content-center'>
  //     <MDBSpinner color='success'>
  //       <span className='visually-hidden'>Loading...</span>
  //     </MDBSpinner>
  //   </div>
  // } 
 
  return (
  
    <section ref={containerRef}>
      <GeographyProvider>
        <MiscProvider>
          <DomainProvider>
           
              <UserProfileProvider>
              <CategoryProvider>
                <NavProvider>
                  <CartProvider>
                    <BrowserRouter>
                      <Navbar showNavCentred={showNavCentred} setShowNavCentred={setShowNavCentred} toggle3barIcon={toggle3barIcon} containerRef={containerRef.current}/>
                      <Sidenav containerRef={containerRef.current} />
                      <Location />
                      <Routes>
                        <Route path="/view/type/:type?" element={<ProtectedRoute element={View} routeType={View} />} />
                        <Route path="/createInvoice" element={<ProtectedRoute element={Invoice} routeType={Invoice} />} />
                        <Route path="/companyCreation" element={<ProtectedRoute element={CreateYourCompany} routeType={CreateYourCompany} />} />
                        <Route path="/idCards" element={<ProtectedRoute element={IdCards} routeType={IdCards} />} />
                        <Route path="/marketing" element={<ProtectedRoute element={CreateThumbnail} routeType={CreateThumbnail} />} />
                        <Route path="/privacypolicy/:main?" element={<ProtectedRoute element={PrivacyPolicy} routeType={PrivacyPolicy} />} />
                        <Route path="/pricing/:id?" element={<ProtectedRoute element={Pricing} routeType={Pricing} />} />
                        <Route path="/" element={(window.location.host.includes('expenses') || window.location.host.includes("x-trk")) ? (<ProtectedRoute element={ExpensesLanding} routeType={ExpensesLanding} />) : (<ProtectedRoute element={Home} routeType={Home} />)} />
                        <Route path="/:isSubscribe?" element={<ProtectedRoute element={ExpensesLanding} routeType={ExpensesLanding} />} />
                        <Route path="/contact" element={<ProtectedRoute element={Contact} routeType={Contact} />} />
                        <Route path="/contactsview" element={<ProtectedRoute element={ContactsView} routeType={ContactsView} />} />
                        <Route path="/home" element={<ProtectedRoute element={Home} routeType={Home} />} />
                        <Route path="/paystub" element={<ProtectedRoute element={PayStub} routeType={PayStub} />} />
                        <Route path="/products" element={<ProtectedRoute element={Products} routeType={Products} />} />
                        <Route path="/shop/:categoryId" element={<ProtectedRoute element={Shop} routeType={Shop} />} />
                        <Route path="/checkout/:pricingCategoryId?" element={<ProtectedRoute element={Checkout} routeType={Checkout} />} />
                        <Route path="/user" element={<ProtectedRoute element={User} />} />
                        <Route path="/report" element={<ProtectedRoute element={Report} />} />
                        <Route path="/statistics" element={<ProtectedRoute element={Statistics} />} />
                        <Route path="/dashboard" element={<ProtectedRoute element={Dashboard} />} />
                        <Route path="/domain/:domainId?/entities" element={<ProtectedRoute element={InventoryView} />} />
                        <Route path="/RequestView" element={<ProtectedRoute element={Requests}/>} />
                        <Route path="/createRequest" element={<ProtectedRoute element={InventoryView}    showCreateButton={true} />} />
                        <Route path="/upload" element={<ProtectedRoute element={UploadEntities} />} />
                        <Route path="/processed/:type?" element={<ProtectedRoute element={Processed} />} />
                        <Route path="/unProcessed/:type?" element={<ProtectedRoute element={UnProcessed} />} />
                        <Route path="/domain/:domainId/users" element={<ProtectedRoute element={UsersView} />} />
                        <Route path="/domain/:domainId/groups" element={<ProtectedRoute element={GroupUserManager} />} />
                        <Route path="/multiView/:key?" element={<ProtectedRoute element={MultiView} />} />
                        <Route path="/domain/:domainId?" element={<ProtectedRoute element={Domain} />} />
                        <Route path="/category/:domainId" element={<ProtectedRoute element={CategoryView} />} />
                        <Route path="/cart" element={<ProtectedRoute element={Cart} routeType={Cart} />} />
                        <Route path="/receipt/:key?/:isProcessed?/:isUnprocessed" element={<ProtectedRoute element={Receipt} />} />
                        <Route path="/qrCodes" element={<ProtectedRoute element={QRCodes} />} />
                        <Route path="/no-requests" element={<ProtectedRoute element={NoRequests} />} />
                        <Route path="/no-receipts/:type?" element={<ProtectedRoute element={NoReceipts} />} />
                        <Route path="/order-view/:fromCheckout?" element={<ProtectedRoute element={Orders} routeType={Orders} />} />
                        <Route path="/no-orders" element={<ProtectedRoute element={NoOrders} routeType={NoOrders} />} />
                        <Route path="/no-inventory" element={<ProtectedRoute element={NoInventory} />} />
                        <Route path="/empty-cart" element={<ProtectedRoute element={EmptyCart} />} />
                        <Route path="/UnderConstruction" element={<ProtectedRoute element={UnderConstruction} />} />
                        <Route path="/user-profile/:id?" element={<ProtectedRoute element={UserProfile} />} />
                        <Route path="/classroomSetup" element={<ProtectedRoute element={ClassroomSetup} />} />
                        
                        <Route path="/addresses/:domainId" element={<ProtectedRoute element={AddressView} />} />
                        <Route path="/demo/builder" element={<ProtectedRoute element={Builder} routeType={Builder} />} /> 
                        <Route path="/sales/questionanswer/form" element={<ProtectedRoute element={RocketDemoBuilderForm} routeType={RocketDemoBuilderForm} />} /> 
                        <Route path="/e-commerce1" element={<ECommerce2 />} />
                        <Route path="/e-commerce2" element={<ECommerce1 />} />
                        <Route path="/ads-dashboard" element={<AdsDashboard />} />
                        <Route path="/order-dashboard" element={<OrderDashboard />} />
                        <Route path="/traffic-dashboard" element={<TrafficDashboard />} />
                        <Route path="/mailbox-app" element={<MailboxApp />} />
                        <Route path="/chat-app" element={<ChatApp />} />
                        <Route path="/invoice-page" element={<InvoicePage />} />
                        <Route path="/seo" element={<SEODashboard />} />
                        <Route path="/org" element={<Org />} />
                        <Route path="/javen-mobile" element={<JavenHome/>} />
                        <Route path="/javen-desktop" element={<JDesk/>} />
                      </Routes>
                      <FooterDynamic  />
                    </BrowserRouter>



                  </CartProvider>
                </NavProvider>
                </CategoryProvider>
              </UserProfileProvider>
            
          </DomainProvider>
        </MiscProvider>
      </GeographyProvider>
    </section>



  );

  

}

export default App;



